import type { components } from '@/types/api/v1'

export type EnvMode = components['schemas']['EnvMode']

/** The toolbar switch's third tab. The request field is optional rather than
 * three-valued, so "All" is the absence of a mode and never reaches the wire. */
export const ALL_MODES = 'all'
export type EnvModeSelection = EnvMode | typeof ALL_MODES

export const ENV_MODE_OPTIONS: { value: EnvModeSelection; label: string }[] = [
  { value: 'Prod', label: 'Prod' },
  { value: 'Test', label: 'Test' },
  { value: ALL_MODES, label: 'All' },
]

/** What the endpoints take: the mode itself, or undefined for "All". */
export function toModeParam(selection: EnvModeSelection): EnvMode | undefined {
  return selection === ALL_MODES ? undefined : selection
}
